import each from 'lodash/each';
import { Breakpoint, createTheme, Theme } from '@mui/material/styles';
import { TypographyPropsVariantOverrides } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import {
  lightThemeParams,
  commonThemeParams,
  darkThemeParams,
} from 'assets/theme/theme';
import { ThemeVariant } from 'assets/theme/themeTypes';
import { pxToRem } from 'utils/constants';

const MEDIA_EDGE = 0;

export type TypographyVariant = keyof TypographyPropsVariantOverrides | Variant;
type GenerateResponsiveFontsOptions = {
  sizesMap: { [key in TypographyVariant]: number[] | null };
  sortedBp: Readonly<Breakpoint[]>;
};

const generateResponsiveFontsOptions: GenerateResponsiveFontsOptions = {
  sizesMap: {
    f8: null,
    f8b: null,
    f10: null,
    f10b: null,
    f12: [12, 12, 12, 12, 12, 12],
    f12b: [12, 12, 12, 12, 12, 12],
    f14: [14, 14, 14, 14, 14, 14],
    f14b: [14, 14, 14, 14, 14, 14],
    f16b: [16, 16, 16, 16, 16, 16],
    f16: [16, 16, 16, 16, 16, 16],
    f18: [18, 18, 18, 18, 18, 18],
    f18b: [18, 18, 18, 18, 18, 18],
    f20: [20, 20, 20, 20, 20, 20],
    f20b: [20, 20, 20, 20, 20, 20],
    f22: [22, 22, 22, 22, 22, 22],
    f24: [24, 24, 24, 24, 24, 24],
    f24b: [24, 24, 24, 24, 24, 24],
    f30: [30, 30, 30, 30, 30, 30],
    f32: [32, 32, 32, 32, 32, 32],
    f38b: [38, 38, 38, 38, 38, 38],
    f42: [42, 42, 42, 42, 42, 42],
    f46: [46, 46, 46, 46, 46, 46],
    h1: null,
    h2: null,
    h3: null,
    h4: null,
    h5: null,
    h6: null,
    subtitle1: null,
    subtitle2: null,
    body1: null,
    body2: null,
    caption: null,
    button: null,
    overline: null,
  },
  // При min-width обязателен порядок по возрастанию!
  sortedBp: [
    'mobile',
    'tablet',
    'laptop',
    'desktop_small',
    'desktop_middle',
    'desktop_large',
  ],
};

const generateResponsiveFonts2 = (
  theme: Theme,
  { sizesMap, sortedBp }: GenerateResponsiveFontsOptions
) => {
  each(sortedBp, (bp, bpIndex) => {
    const mediaString = theme.breakpoints.up(bp);
    const bpWidth = theme.breakpoints.values[bp];

    if (bpWidth <= MEDIA_EDGE) {
      return;
    }

    // Заглушка от нуля до нижнего брикпоинта
    each(sizesMap, (values, key) => {
      const mediaString = theme.breakpoints.up(0);
      const variant = key as TypographyVariant;

      if (!values) {
        const baseSize = theme.typography[variant].fontSize;
        // @ts-ignore
        theme.typography[variant][mediaString] = {
          fontSize: baseSize,
        };
        return;
      }

      // @ts-ignore
      theme.typography[variant][mediaString] = {
        fontSize: `${pxToRem(values[0])}rem`,
      };
    });

    each(sizesMap, (values, key) => {
      const variant = key as TypographyVariant;

      if (!values) {
        const baseSize = theme.typography[variant].fontSize;
        // @ts-ignore
        theme.typography[variant][mediaString] = {
          fontSize: baseSize,
        };
        return;
      }

      // @ts-ignore
      theme.typography[variant][mediaString] = {
        fontSize: `${pxToRem(values[bpIndex])}rem`,
      };
    });
  });

  return theme;
};

export const constructTheme = (variant: ThemeVariant) => {
  switch (variant) {
    case ThemeVariant.LIGHT:
      return generateResponsiveFonts2(
        createTheme({ ...lightThemeParams, ...commonThemeParams }),
        generateResponsiveFontsOptions
      );
    case ThemeVariant.DARK:
      return generateResponsiveFonts2(
        createTheme({ ...darkThemeParams, ...commonThemeParams }),
        generateResponsiveFontsOptions
      );
  }
};
